export default {"src":"/_next/static/media/next-icon.1b03d3a4.svg","height":113,"width":65};